export default __webpack_public_path__ + "static/media/arrowHeadLoop.cb9781fd.svg";